var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header--sm mb-2",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.list)?_c('description-list',{attrs:{"list":_vm.list}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }